import { render, staticRenderFns } from "./JoinInfoProtectionModal.vue?vue&type=template&id=2dfb0382&scoped=true&"
import script from "./JoinInfoProtectionModal.vue?vue&type=script&lang=js&"
export * from "./JoinInfoProtectionModal.vue?vue&type=script&lang=js&"
import style0 from "./JoinInfoProtectionModal.vue?vue&type=style&index=0&id=2dfb0382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb0382",
  null
  
)

export default component.exports